<template>
    <div class="main">
        <div class="bg-white">
            <div class="accountRateFlowers__container container mx-auto text-center px-4 pt-12 pb-4">
                <p v-text="$t('RATE_MY_FLOWERS_TO_HEAR')"></p>
                <p v-text="$t('RATE_MY_FLOWERS_PLEASE_LET')"></p>

                <subscription-dropdown
                    v-if="hasMultipleActiveSubscriptions"
                    class="accountRateFlowers__subscriptionDropdown">
                </subscription-dropdown>
            </div>
        </div>
        <div class="background--paper divider--container">
            <div class="divider-white--top"></div>
            <transition name="transitionFade">
                <rate-arrangement
                    v-if="activeSubscription"
                    :key="activeSubscription.id">
                </rate-arrangement>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RateArrangement from '@/components/partials/account/rate-my-flowers/RateArrangement';
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';

export default {
    name: 'RateMyFlowers',
    created() {
        this.$store.dispatch('subscription/fetchAllSubscriptions');
        this.$store.dispatch('address/fetchAllAddresses');
        this.$store.dispatch('cms/fetchRateableArrangements');
    },
    computed: {
        ...mapGetters({
            hasMultipleActiveSubscriptions: 'subscription/hasMultipleActiveSubscriptions',
            activeSubscription: 'subscription/getActiveSubscription',
        }),
    },
    components: {
        SubscriptionDropdown,
        RateArrangement,
    },
};
</script>
